import React, {  useRef,useState,useEffect ,Fragment } from "react";
import { Table, Pagination, Badge,Dropdown,Spinner } from "react-bootstrap";

import PageTitle from "../layouts/PageTitle";

import { useDispatch,useSelector } from "react-redux";

import { Link } from "react-router-dom";

import axiosInstance from '../../services/AxiosInstance';
import swal from "sweetalert";

import { format } from "date-fns";

import OrderTable from "./OrdersTable2";

import { CSVLink } from "react-csv";

//const Orders = () => {
   const Orders = ({ props, history }) => {

   const dispatch = useDispatch();
   const [orders, setOrders] = useState([]);
   const [xlsData, setXlsData] = useState([]);
   const [loading, setLoading] = useState(true);


   const [orderStatus, setOrderStatus] = useState("All");
   const [paymentStatus, setPaymentStatus] = useState("All");


    const [search, setSearch] = useState("");
   const [searchTimeout, setSearchTimeout] = useState(null);

   useEffect(() => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      setSearchTimeout(
        setTimeout(() => {
         loadOrders();
        }, 1000),
      );

      return () => clearTimeout(searchTimeout);
    }, [search]);

  
  
   useEffect(() => {
		loadOrders();
	}, [dispatch]);


   useEffect(() => {

      if(orders){
         //setLoading(false);
      }
     
	}, [orders]);


   const loadOrders = async () => {
      setLoading(true);
      const { data } = await axiosInstance.post(
         "admin/orders",
         {
            status:orderStatus,
            payment_status:paymentStatus,
            search:search
         }
       );
 
       if(data.status){
         setOrders(data.orders);
       }
       setLoading(false);
   }

   const changeOrderStatusFilter = async (filter) => {
      await setOrderStatus(filter);
      loadOrders();
   }

   const changePaymentStatusFilter = async (filter) => {
      await setPaymentStatus(filter);
      loadOrders();
   }


   
   const initXlsData = async () => {

      var dummy = [];
      orders.map((data,i)=>{

      
         dummy.push({
            sr_no:i+1,
            id:data.id,
            name:data.userId.name,
            email:data.userId.email,
            phone:data.userId.phone,
            
            pack:data.packId.type+" "+data.packId.name,
            counters:data.packId.counter,

            status:data.status,
            payment_status:data.paymentStatus,

            discount:data.discountTotal,
            sub_total:data.orderTotal + data.discountTotal, 
            
            total:data.orderTotal,

            created_at:format(new Date(data.createdAt), "dd/MM/yyyy H:mma"),

            
         });
      });


      setXlsData(dummy);


   }
   


   
   return (

      <Fragment>
         {/* <PageTitle activeMenu="Datatable" motherMenu="Table" /> */}

      <div className="col-12">
         <div className="card">
            <div className="card-header">
               <h4 className="card-title mr-auto">Orders</h4>

               <div className="input-group search-area d-lg-inline-flex d-none mr-2">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (searchTimeout) {
                      clearTimeout(searchTimeout);
                    }
                    loadOrders();
                  }}
                >
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </form>
                <div className="input-group-append">
                  <span className="input-group-text">
                    <svg
                      width={20}
                      height={20}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.7871 22.7761L17.9548 16.9437C19.5193 15.145 20.4665 12.7982 20.4665 10.2333C20.4665 4.58714 15.8741 0 10.2333 0C4.58714 0 0 4.59246 0 10.2333C0 15.8741 4.59246 20.4665 10.2333 20.4665C12.7982 20.4665 15.145 19.5193 16.9437 17.9548L22.7761 23.7871C22.9144 23.9255 23.1007 24 23.2816 24C23.4625 24 23.6488 23.9308 23.7871 23.7871C24.0639 23.5104 24.0639 23.0528 23.7871 22.7761ZM1.43149 10.2333C1.43149 5.38004 5.38004 1.43681 10.2279 1.43681C15.0812 1.43681 19.0244 5.38537 19.0244 10.2333C19.0244 15.0812 15.0812 19.035 10.2279 19.035C5.38004 19.035 1.43149 15.0865 1.43149 10.2333Z"
                        fill="#A4A4A4"
                      />
                    </svg>
                  </span>
                </div>
              </div>

               <Dropdown className="mr-2">
  <Dropdown.Toggle variant="light" id="dropdown-basic">
    {paymentStatus} Payment
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item onClick={(e)=>changePaymentStatusFilter("All")}>All Payment</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changePaymentStatusFilter("paid")}>Paid</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changePaymentStatusFilter("unpaid")}>Unpaid</Dropdown.Item>
   
  </Dropdown.Menu>
</Dropdown>


               <Dropdown className="mr-2">
  <Dropdown.Toggle variant="light" id="dropdown-basic">
    {orderStatus} Orders
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item onClick={(e)=>changeOrderStatusFilter("All")}>All Orders</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changeOrderStatusFilter("Completed")}>Completed Orders</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changeOrderStatusFilter("Processing")}>Processing Orders</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changeOrderStatusFilter("On Hold")}>On Hold Orders</Dropdown.Item>
    <Dropdown.Item onClick={(e)=>changeOrderStatusFilter("Pending")}>Pending Orders</Dropdown.Item>
   
  </Dropdown.Menu>
</Dropdown>

               
               <CSVLink
  data={xlsData}
  filename={"orders.csv"}
  className="btn btn-primary"
  target="_blank"
  asyncOnClick={true}
  onClick={async (event, done) => {
   console.log("You click the link");
   await initXlsData();
   done(); // 👍🏻 You are stopping the handling of component
 }}

>
  Export
</CSVLink>
            </div>
            <div className="card-body">

               {loading ? (<div className="text-center mt-4"><Spinner animation="border" variant="primary" /></div>):
              
              (orders.length == 0 ? (<p>No Orders</p>):(<OrderTable orders={orders}></OrderTable>))}
       
             
         </div>
      </div>
      </div>

      </Fragment>
   );
};

export default Orders;
